<style scoped>
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.v-application .white {
  border: #ccd0d9 solid 1px !important;
}
</style>

<template>
  <v-container fluid>
    <v-layout class="d-flex justify-space-between">
      <div class="text-h4 font-weight-black primary--text text-spacing" color="blue">ข้อมูลพนักงาน</div>
      <v-spacer></v-spacer>

      <v-btn color="success" elevation="0" dark link :to="'/Manage/add-personnel'" >
        <v-icon left>mdi-file-plus</v-icon>เพิ่มพนักงาน
      </v-btn>
    </v-layout>
    <v-divider class="my-2"></v-divider>
    <v-layout v-resize="onResize" column class="pt-5">
      <v-data-table :headers="headers" :items="desserts" :search="search">
        
         <template v-slot:[`item.actions`]="{ item }">
        <TableMenuCustomer :TableData="item"  :whichPage="'person_Edit'" v-on:myEvent="initialize" ></TableMenuCustomer>
      </template>
        <template v-slot:item.edit="{ item }">
          <v-btn color="info" small class="mb-0 font-weight-bold" @click="edit_carrier(item)">
            <v-icon left>mdi-file-document-edit-outline</v-icon>แก้ไข
          </v-btn>
        </template>
        <template v-slot:item.delete="{ item }">
          <v-btn color="warning" small class="mb-0 font-weight-bold" @click="delete_carrier(item)">
            <v-icon left>mdi-trash-can-outline</v-icon>ลบ
          </v-btn>
        </template>
        <template v-slot:no-data>
          <v-btn color="info" @click="initialize">
            <v-icon left>mdi-refresh</v-icon>รีเฟรชข้อมูล
          </v-btn>
        </template>
        <v-alert
          slot="no-results"
          :value="true"
          color="error"
          icon="warning"
        >Your search for "{{ search }}" found no results.</v-alert>
      </v-data-table>
    </v-layout>
  </v-container>
</template>

<script>
import TableMenuCustomer from '../components/TableMenuCustomer'
export default {
  components:{
    TableMenuCustomer
  },
  data: () => ({
    fav: true,
    menu: false,
    message: false,
    hints: true,
    pagination: {
      sortBy: "name",
    },
    selected: [],
    search: "",
    isMobile: false,
    headers: [
        {
          text: "ตำแหน่ง",
          align: "start",
          sortable: true,
          value: "PERSONNEL_POSITION",
        },
        { text: "ชื่อ-สกุล", value: "PERSONNEL_FULLNAME" },
        { text: "เบอร์โทร", value: "PERSONNEL_PHONE" },
        { text: "", value: "actions" },
        // { text: "แก้ไข", value: "edit", width: "10%" },
        // { text: "ลบ", value: "delete", width: "10%" },
      ],
    desserts: [
     
    ],
  }),
created(){
  this.list_all_preson()
  
  this.$store.dispatch("Personnel/preson_reset");
},
  methods: {
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.desserts.slice();
    },
    changeSort(column) {
     
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    list_all_preson(){
      this.$token_api.get('/list-Personnel').then((res) => {
        this.desserts = res.data.data
      }).catch((err) => {
        console.log(err);
      })
    },
    initialize(){
      this.list_all_preson()
    },
  
  },
};
</script>